import { JOIN_STEPS_ORDER, type TJoinDestination, type TJoinStep } from '../models/joinSteps.types'

type TGetNextJoinStepOptions = {
  isVirtus: boolean
}

const getTerminal = (isVirtus: boolean): TJoinDestination => (isVirtus ? 'community' : 'congrats')

/**
 * Next destination after `stepName`.
 * When `stepName` is absent from `steps`, opens the next canonical step that is in the list
 * (or the funnel terminal if none remain).
 */
export const getNextJoinStep = (
  stepName: TJoinStep,
  steps: TJoinStep[],
  { isVirtus }: TGetNextJoinStepOptions,
): TJoinDestination => {
  const index = steps.indexOf(stepName)
  if (index >= 0) {
    return steps[index + 1] ?? getTerminal(isVirtus)
  }

  const orderIndex = JOIN_STEPS_ORDER.indexOf(stepName)
  for (let i = orderIndex + 1; i < JOIN_STEPS_ORDER.length; i++) {
    const candidate = JOIN_STEPS_ORDER[i]
    if (candidate && steps.includes(candidate)) {
      return candidate
    }
  }

  return getTerminal(isVirtus)
}
